import React from 'react';
import fonts from './fonts.css';
import fontSubPage from './fonts_subpage.css';

function Fonts({ subPage = false }) {
  return (
    <>
      {subPage ? (
        <style jsx global>
          {fontSubPage}
        </style>
      ) : (
        <style jsx global>
          {fonts}
        </style>
      )}
    </>
  );
}

export default Fonts;
